import { useEffect } from "react";
import { Analytics } from "@vercel/analytics/react";
import { MotionConfig } from "framer-motion";
import "./App.css";
import Router from "./config/router";
import SmoothScroll from "./components/SmoothScroll";
import ScrollProgress from "./components/ScrollProgress";
import IntroLoader from "./components/IntroLoader";
import { preloadCriticalImages } from "./utils/imagePreloader";

function App() {
  useEffect(() => {
    preloadCriticalImages().catch((err) => {
      console.warn("Failed to preload some images:", err);
    });
  }, []);

  return (
    <SmoothScroll>
      <IntroLoader />
      <ScrollProgress />
      <div className="bg-app min-h-screen relative">
        <div className="aurora-bg">
          <div className="aurora-blob b1" />
          <div className="aurora-blob b2" />
        </div>
        <div className="relative z-[1]">
          {/* reducedMotion="user" turns off transform animations when the OS asks for less motion */}
          <MotionConfig reducedMotion="user">
            <Router />
          </MotionConfig>
        </div>
      </div>
      <Analytics />
    </SmoothScroll>
  );
}

export default App;
